import React from "react"
import clsx from "clsx"
import I18n from "i18n-js"

class BookingButtonPresenterForm extends React.Component {

  constructor(props) {
    super(props)  
  }

  render() {
    var tabClasses = clsx ({
      'active': this.props.active_tab == 'form',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="form">
        <div className="row">
          <div className="col-sm-5 form-group" style={{marginBottom: 0}}>
            <div className="form-conntrol">
              <label>{I18n.t("form")}{" "}
                <span className="ss-help help" title={I18n.t("booking_button_order_form_helper_text")}></span>
              </label> 
              {this.props.form == null 
                ? 
                  <div><i>{I18n.t('none')}</i></div> 
                :
                  <div>{this.props.form.title}</div>      
              }       
            </div>
          </div>
        </div>  
      </div>
    )
  }
}

export default BookingButtonPresenterForm